import { TreeNode } from 'primeng/primeng';
import { forEach } from '@angular/router/src/utils/collection';

export class FileNode implements TreeNode {
    public data : FileInfo;
    public leaf = false;
    public children?: FileNode[] = [];
    public parent?:FileNode;
    public get hasBeta(){
        if (!this.children || this.children.length == 0) return false;
        for (let i =0; i<this.children.length;i++){
            if (this.children[i].data && !this.children[i].data.beta){
                return false;
            }
        }
        return true;
    }
    public get hasArchive(){
        if (!this.children || this.children.length == 0) return false;
        for (let i =0; i<this.children.length;i++){
            if (this.children[i].data && !this.children[i].data.archive){
                return false;
            }
        }
        return true;
    }
    public clone(): FileNode {
        let result = new FileNode();
        result.leaf = this.leaf;
        result.data = this.data
        return result;
    }
  }

export class FileInfo{
    public name: string;
    //public release : boolean = false;
    private _order :number = null;
    public archive: boolean;
    public beta:boolean;
    public release:boolean;

    public date : Date;
    public get isDirectory() : boolean{
        return this.name.endsWith('/');
    }
    // public get releaseLabel(): string{
    //     if (this.isDirectory || this.isMarkdown) return '';
    //     if (this.release) return 'yes';
    //     return 'no';
    // }
    public get isMarkdown() :boolean{
        return this.name.toLowerCase().endsWith('.md');
    }

    public get order() : number {
        if (this._order != null){
            this._order;
        }
        let parts = this.displayName.split('.');
        if (parts.length!=3){
            this._order = 0;
            return this._order;            
        }
        try{
        let partsNumber = parts.map(p=>parseInt(p));
        this._order = partsNumber[0] * 100  *1000 + partsNumber[1]  * 1000 + partsNumber[2];
      
        return this._order;
        } catch(e){
            this._order = 0;
            return this._order; 
        }
    }
    public  get size() {
        if (this.contentLength) {
        return (this.contentLength/(1024*1024)).toFixed(2) + " MB";
        } else {
            return "";
        }
    }
    public contentLength : number;
    public get displayName() :string{
        let parts = this.name.split('/');
        if (this.name.endsWith('/')) {
            return parts[parts.length-2];
        } else {
            return parts[parts.length-1];
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/models/filenode.ts